var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable @rushstack/security/no-unsafe-regexp */
/* eslint-disable no-constant-condition */
import React, { useContext, useEffect, useState } from 'react';
import { Absolute, Box, ChatMessage, Flex, Text } from 'pcln-design-system';
import { format } from 'date-fns/format';
import { VoteType } from './chatTypes';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { TravelBotLogoImage } from './TravelBotLogoImage';
import VoteUp from './Assets/VoteUp';
import VoteDown from './Assets/VoteDown';
import styled from 'styled-components';
import { feedbackPost } from './utils/feedbackPost';
import analytics from './analytics/analytics';
import { motion } from 'framer-motion';
import { marked } from 'marked';
import { addTargetAttrToHyperLink } from './utils/addTargetAttrToHyperLink';
import { v4 as uuidV4 } from 'uuid';
const COSTUMER_SUPPORT_NUMBER = '1-877-477-5807';
const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
const blockedKeywords = ['javascript', 'window.open', 'script', 'eval', 'window.opener', 'window.document', '<embed', 'onerror', 'onload',
// eslint-disable-next-line no-script-url
'javascript:', 'alert', 'document.cookie', 'window.location', 'setTimeout', 'setInterval', 'innerHTML'];
const VoteWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "TravelBotChatSingleDialogGeneric__VoteWrapper",
  componentId: "sc-ngfa66-0"
})(["cursor:pointer;"]);
const CustomChatMessage = /*#__PURE__*/styled(ChatMessage).withConfig({
  displayName: "TravelBotChatSingleDialogGeneric__CustomChatMessage",
  componentId: "sc-ngfa66-1"
})(["overflow-wrap:anywhere;& div:nth-child(2){width:fit-content;}"]);
const ChatMessageWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "TravelBotChatSingleDialogGeneric__ChatMessageWrapper",
  componentId: "sc-ngfa66-2"
})(["p{margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;margin-bottom:8px;font-size:", "px;}p:last-child{margin-bottom:0;}strong{font-weight:bold;}"], props => props.theme.fontSizes[props.fontSize]);
/**
 * TravelBotChatSingleDialogGeneric
 * Support showing message content for assistan/user
 * @public
 */
export const TravelBotChatSingleDialogGeneric = props => {
  const {
    logCustomerCarePhoneNumberClicked,
    logCustomerCarePhoneNumberDisplayed,
    isMobile,
    submitChatMessagesPayload,
    fetchRequestOptions
  } = useContext(ChatbotDataContext);
  const {
    message
  } = props;
  const {
    rguid,
    cguid
  } = submitChatMessagesPayload !== null && submitChatMessagesPayload !== void 0 ? submitChatMessagesPayload : {};
  const {
    content,
    role,
    vote = VoteType.NONE
  } = message;
  const [voteStatus, setVoteStatus] = useState(vote);
  const [voteSubmitted, setVoteSubmitted] = useState(false);
  const isAssistant = role === 'assistant';
  const isNotUser = isAssistant;
  function phoneNumberClicked() {
    if (logCustomerCarePhoneNumberClicked && typeof logCustomerCarePhoneNumberClicked === 'function') {
      logCustomerCarePhoneNumberClicked();
    }
  }
  function sanitizeText(text) {
    const regex = new RegExp(blockedKeywords.join('|'), 'gi');
    return text.replace(regex, '');
  }
  useEffect(() => {
    window.phoneNumberClicked = phoneNumberClicked;
    return () => {
      window.phoneNumberClicked = null;
    };
  }, []);
  const MessageIcon = function Icon(props) {
    if (isAssistant) {
      return React.createElement(TravelBotLogoImage, null);
    }
    return null;
  };
  const footerMessagePrefix = isAssistant ? 'Penny' : '';
  const transformedDate = (message === null || message === void 0 ? void 0 : message.date) ? new Date(message.date).valueOf() : undefined;
  const footerMessageDateString = transformedDate && typeof transformedDate === 'number' ? format(message === null || message === void 0 ? void 0 : message.date, "LLL d 'at' h:mm:ss aaa") : '';
  const handleVoteStatus = status => {
    setVoteStatus(status);
  };
  const handleFeedbackSubmit = (vote, feedback) => __awaiter(void 0, void 0, void 0, function* () {
    const feedbackId = uuidV4();
    try {
      if (!voteSubmitted) {
        const {
          headers
        } = fetchRequestOptions;
        const baseUrl = '/genai-svc/genai/chat/feedback';
        yield feedbackPost({
          feedback: feedback !== null && feedback !== void 0 ? feedback : '',
          message: Object.assign(Object.assign({}, props.message), {
            vote
          }),
          conversationId: rguid,
          feedbackId,
          cguid
        }, baseUrl, headers);
        setVoteSubmitted(true);
      }
    } catch (e) {
      analytics.log({
        source: 'feedback error',
        message: e,
        cguid,
        feedbackId,
        conversationId: rguid
      });
    }
  });
  const showVoteUp = voteStatus === VoteType.NONE || voteStatus === VoteType.UP;
  const showVoteDown = voteStatus === VoteType.NONE || voteStatus === VoteType.DOWN;
  const isGreetingMessage = GREETING_MESSAGE === message.content;
  const voteGap = isMobile ? 4 : 3;
  const Footer = footerMessageDateString ? React.createElement(motion.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    }
  }, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: isNotUser ? 'space-between' : 'flex-end'
  }, footerMessagePrefix && React.createElement(Absolute, {
    width: 0.96,
    top: '-10px'
  }, React.createElement(Flex, {
    justifyContent: 'space-between',
    width: 1
  }, React.createElement(Text, {
    color: 'text.light',
    textStyle: 'subheading6'
  }, footerMessagePrefix, " \u00B7 ", footerMessageDateString), !isGreetingMessage ? React.createElement(Flex, null, showVoteUp ? React.createElement(VoteWrapper, {
    mr: showVoteUp && !showVoteDown ? 0 : voteGap,
    onClick: function () {
      return __awaiter(this, void 0, void 0, function* () {
        handleVoteStatus(VoteType.UP);
        yield handleFeedbackSubmit(VoteType.UP, '');
      });
    }
  }, React.createElement(VoteUp, {
    isActive: voteStatus === VoteType.UP
  })) : null, showVoteDown ? React.createElement(VoteWrapper, {
    onClick: function () {
      return __awaiter(this, void 0, void 0, function* () {
        handleVoteStatus(VoteType.DOWN);
        yield handleFeedbackSubmit(VoteType.DOWN, '');
      });
    }
  }, React.createElement(VoteDown, {
    isActive: voteStatus === VoteType.DOWN
  })) : null) : null)), !footerMessagePrefix && React.createElement(Text, {
    color: 'text.light',
    textStyle: 'subheading6'
  }, footerMessageDateString))) : null;
  function getMarkdownText(text) {
    const rawMarkup = marked.parse(sanitizeText(text));
    return {
      __html: rawMarkup
    };
  }
  function convertToTelLink(phoneNumber) {
    if (phoneNumber === COSTUMER_SUPPORT_NUMBER && logCustomerCarePhoneNumberDisplayed && typeof logCustomerCarePhoneNumberDisplayed === 'function') {
      logCustomerCarePhoneNumberDisplayed();
    }
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    return phoneNumber === COSTUMER_SUPPORT_NUMBER ? `<a href="tel:${cleanNumber}" onclick="window.phoneNumberClicked()" >${phoneNumber}</a>` : `<a href="tel:${cleanNumber}">${phoneNumber}</a>`;
  }
  const filterMessage = content => {
    // Convert phone number to tel link
    content = content.replace(/\*\*(1?[-.]?\d{3}[-.]?\d{3}[-.]?\d{4})\*\*/g, (_, phoneNumber) => {
      return convertToTelLink(phoneNumber);
    });
    // Convert to Markdown format
    const markdownText = getMarkdownText(content);
    // Add '_target' attribute to hyperlink to open link in new window
    markdownText.__html = addTargetAttrToHyperLink(markdownText.__html);
    return markdownText;
  };
  return React.createElement(CustomChatMessage, {
    "data-testid": isNotUser ? 'pennyCCM' : 'userCCM',
    mb: isNotUser ? '40px' : 4,
    ml: isNotUser ? '' : 'auto',
    variation: isNotUser ? 'initial' : 'outgoing',
    Icon: MessageIcon,
    message: React.createElement(ChatMessageWrapper, {
      fontSize: 2
    }, React.createElement("div", {
      //@ts-ignore
      dangerouslySetInnerHTML: filterMessage(content)
    })),
    footer: Footer
  });
};